import MagnifierControl from './magnifier-control';
import us from '../../defines';
import app from '../../public-api';

const loader = {
  name: 'us:magnifier',

  extends: 'viewport',

  dependencies: [
    'us:user-config',
    'us:settings:visibility-panel'
  ],

  canStart () {
    return us.ENABLEMAG;
  },

  constructor: MagnifierControl
};

app.plugins.register(loader);
